// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609231727/js/" + chunkId + "." + {"44":"69ae7d90","225":"5786330b","481":"68d91a97","486":"9aa3c585","770":"f761b715"}[chunkId] + ".0.10407325572523551.chunk.js";
};